var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCameraOff = function SvgIconCameraOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(-605.000000, -842.000000) translate(605.527988, 842.763994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.472,
    height: 52.472,
    rx: 26.236
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FB355D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.364 16.364v1.09c0 1.206-.977 2.182-2.182 2.182h-12C.977 19.636 0 18.66 0 17.455V6.545C0 5.34.977 4.364 2.182 4.364h2.182m6.174 0h3.644c1.205 0 2.182.976 2.182 2.181v3.644l1.09 1.091L24 6.545v10.91M0 0L24 24",
    transform: "translate(-605.000000, -842.000000) translate(605.527988, 842.763994) translate(14.472012, 15.236006)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCameraOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-camera-off.0920cfc09597d0738a79aa79c3ffd954.svg";